// extracted by mini-css-extract-plugin
module.exports = {"Letters":"LetterList_Letters__2Pn0T"};